// ** Third Party Imports
import styled, { type CSSProperties, keyframes } from 'styled-components'
import * as Dialog from '@radix-ui/react-dialog'

import { zIndex } from '@/shared/styles'

// ** Component Imports
import { Heading } from '../Heading'
import { IconButton } from '../IconButton'

const slideInFromRight = keyframes`
	from {
		transform: translateX(100%);
		opacity: 0;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
`

export const StyledOverlay = styled(Dialog.Overlay) <{
	$styles?: CSSProperties
}>`
	inset: 0;
	z-index: ${zIndex.dialogOverlay};
	position: fixed;
	background-color: rgba(0, 0, 0, 0.2);
	${({ $styles }) => $styles && { ...$styles }}
`

export const StyledContent = styled(Dialog.Content)`
	width: 90vw;
	outline: none;
	max-width: 30.5rem;
	max-height: 85vh;
	padding: 1.5rem;
	overflow-y: auto;
	box-shadow: 0px 2px 8px 0px rgba(9, 106, 99, 0.25);
	border-radius: 0.5rem;
	background-color: ${({ theme }) => theme.pallette.geniiWhite};
	position: relative;
	z-index: ${zIndex.dialog};

	&.drawer {
		max-height: 100vh;
		height: 100vh;
		border-radius: 0;
		animation: ${slideInFromRight} 320ms cubic-bezier(0.22, 0.61, 0.36, 1);
	}
	&.drawer-right {
		padding: 0;
		max-height: 100vh;
		height: 100vh;
		border-radius: 0;
		animation: ${slideInFromRight} 320ms cubic-bezier(0.22, 0.61, 0.36, 1);
	}
	&.max-width-40rem {
		max-width: 45rem;
	}
	&.max-width-30rem {
		max-width: 30rem;
	}
	&.max-width-50rem {
		max-width: 50rem;
	}
`

export const ContentPosition = styled.div<{ $styles?: CSSProperties }>`
	top: 50%;
	left: 50%;
	z-index: ${zIndex.dialog};
	position: fixed;
	transform: translate(-50%, -50%);
	${({ $styles }) => $styles && { ...$styles }}
`

export const CloseButton = styled(IconButton) <{ $styles?: CSSProperties }>`
	position: absolute;
	right: 1.5rem;
	top: 1.5rem;
	color: ${({ theme }) => theme.pallette.text.black75};
	${({ $styles }) => ({ ...$styles })}
`

export const StyledHeading = styled(Heading)`
	margin-bottom: 2rem;
	color: ${({ theme }) => theme.pallette.text.black75};
`
